import ApiService, { ApiArguments } from '@/api/api_service';
import {
  OpportunityStageMasterApi,
} from '@/api/openapi';

export class OpportunityStageMasterApiApiService extends ApiService {
  api = new OpportunityStageMasterApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getOpportunityStageMasters() {
    return this.api.getOpportunityStageMasters();
  }

  async postOpportunityStageMasters(request) {
    return this.api.postOpportunityStageMasters(request);
  }

  async putOpportunityStageMasters(request) {
    return this.api.putOpportunityStageMasters(request);
  }

  async deleteOpportunityStageMasters(request) {
    return this.api.deleteOpportunityStageMasters(request);
  }
}
